"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnOutsideClick = void 0;
const react_1 = require("react");
const useOnOutsideClick = (ref, handler) => {
    return (0, react_1.useEffect)(() => {
        const listener = (event) => {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
};
exports.useOnOutsideClick = useOnOutsideClick;
